export default "__VITE_ASSET__BTrnoW$5__"